import { IUIPreferencesModel } from '@Shared/models';

export const STORE_UI_PREFERENCES = 'STORE_UI_PREFERENCES';

export class StoreUIPreferences {
  readonly type = STORE_UI_PREFERENCES;

  constructor(public uiPreferences: IUIPreferencesModel) {}
}

export type UIPreferencesAction = StoreUIPreferences;
